module.exports = __webpack_public_path__ + "static/media/011-Aufraeumen_oV_ID_3.c8b68ff6.mp3";